import { EnumOption } from "./enum-option"

export const CompanyPartnerType = {
    None: 0,
    Trinet: 1,
    FormerTrinet: 2,   
}

export const CompanyPartnerTypeList: EnumOption[] = [
    { value: CompanyPartnerType.None, label: 'None' },
    { value: CompanyPartnerType.Trinet, label: 'Trinet' },
    { value: CompanyPartnerType.FormerTrinet, label: 'Former Trinet' },   
]
